import { apiCall } from '@/lib/api-client';
import type {
  StartScreeningInput,
  SaveAnswerInput,
  LogTimeEventInput,
  SubmitScreeningInput,
} from '@/types/api';


export interface ResumedAnswer {
  domain: string;
  answer: Record<string, unknown>;
  notes: string | null;
  positiveFinding: boolean | null;
}

export interface ResumedScreening {
  id: string;
  assignmentId: string;
  clientId: string;
  agentId: string;
  startedAt: string;
  submittedAt: string | null;
  isSubmitted: boolean;
  consentGiven: boolean;
  recordingNoticeGiven: boolean;
  languageUsed: string;
  safetyTotalScore: number | null;
  answers: ResumedAnswer[];
}

interface StartedScreening {
  id: string;
  assignmentId: string;
  clientId: string;
  agentId: string;
  startedAt: string;
  consentGiven: boolean;
  recordingNoticeGiven: boolean;
  languageUsed: string;
  isSubmitted: boolean;
}

export const screeningApi = {
  get: (id: string) =>
    apiCall<ResumedScreening>(`/screenings/${id}`, { method: 'GET' }),

  start: (input: StartScreeningInput) =>
    apiCall<StartedScreening>('/screenings', {
      method: 'POST',
      body: input,
    }),

  saveAnswer: (id: string, input: SaveAnswerInput) =>
    apiCall<unknown>(`/screenings/${id}/answer`, {
      method: 'PATCH',
      body: input,
    }),

  logEvent: (id: string, input: LogTimeEventInput) =>
    apiCall<{ id: string }>(`/screenings/${id}/events`, {
      method: 'POST',
      body: input,
    }),

  cancel: (id: string) =>
    apiCall<{ ok: boolean; assignmentId: string }>(`/screenings/${id}/cancel`, { method: 'POST' }),

  submit: (id: string, input: SubmitScreeningInput) =>
    apiCall<unknown>(`/screenings/${id}/submit`, {
      method: 'POST',
      body: input,
    }),
};
